import sanitizeHtml from 'sanitize-html';

const sanitizerConfig = {
  allowedTags: sanitizeHtml.defaults.allowedTags.concat([
    'img',
    'a',
    'svg',
    'path',
  ]),
  allowedSchemes: ['data', 'https', 'mailto', 'tel'],
  allowedAttributes: {
    ...sanitizeHtml.defaults.allowedAttributes,
    '*': ['style'],
    svg: ['width', 'height', 'viewBox', 'fill'],
    path: ['d'],
  },
  parseStyleAttributes: false,
  parser: {
    lowerCaseTags: false,
    lowerCaseAttributeNames: false,
  },
};

const sanitize = content => sanitizeHtml(content, sanitizerConfig);

export { sanitize, sanitizerConfig };
